import { memo } from "react";
import { GoogleMap, useLoadScript, MarkerF } from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "250px",
};

// onMapClick(lat, lng): fires when the map itself is clicked/tapped.
// draggableMarker: makes the existing marker draggable.
// onMarkerDragEnd(lat, lng): fires once the marker is dropped after a drag.
// Both callbacks are optional so existing read-only usages of this
// component (just showing a pin, no interaction) keep working unchanged.
function MapComponent({ center, zoom, isMarker, onMapClick, draggableMarker, onMarkerDragEnd }) {
    const { isLoaded } = useLoadScript({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
        libraries: ["places"],
    });

    const handleMapClick = (e) => {
        if (onMapClick) {
            onMapClick(e.latLng.lat(), e.latLng.lng());
        }
    };

    const handleMarkerDragEnd = (e) => {
        if (onMarkerDragEnd) {
            onMarkerDragEnd(e.latLng.lat(), e.latLng.lng());
        }
    };

    return isLoaded ? (<GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        onClick={handleMapClick}
        options={{ cursor: onMapClick ? "pointer" : "grab" }}
    >
        {isMarker && (
            <MarkerF
                position={center}
                draggable={!!draggableMarker}
                onDragEnd={handleMarkerDragEnd}
            />
        )}
    </GoogleMap>
    ) : (<></>);
}

export default memo(MapComponent);